import BaseDataGrid from "./BaseDataGrid";

export default BaseDataGrid;
